import { useMemo } from "react";
import { Page } from "../../types";
import styles from "./index.module.scss";
import classes from "classnames";

export interface PageCardProps {
  page: Omit<Page, "components">;
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
}

const PageCard = ({ page, className, onClick, fullWidth }: PageCardProps) => {
  const statusText = useMemo<string>(() => {
    if (page.status === "lock") {
      return "未解锁";
    }
    if (page.status === "undo") {
      return "未学习";
    }
    if (page.status === "done") {
      return "已完成";
    }
    return "";
  }, [page]);

  const handleCardClick = () => {
    onClick?.();
  };

  return (
    <div
      className={classes(
        styles.pageCard,
        styles[page.status],
        fullWidth && styles.fullWidth,
        className
      )}
      onClick={handleCardClick}
    >
      <div className={styles.title}>
        {page.number} {page.title}
      </div>
      <div className={styles.subtitle}>{page.summary}</div>
      <div className={styles.footer}>
        <div className={styles.status}>{statusText}</div>
        <div className={styles.icon} />
      </div>
    </div>
  );
};

export default PageCard;
